import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
import { CROP_AREA_COLOR } from './cropAreaColor';

/** Region 4A coconut COG (overviews). The non-COG `region4a_coconut.tif` will not tile reliably. */
export const COCONUT_CROP_COG_URL =
  'https://digisaka.s3.amazonaws.com/region4a_coconut_cog.tif';

/** Raster extent from TiTiler /info (EPSG:4326) — fly-to when the layer is enabled. */
export const COCONUT_CROP_BBOX: [number, number, number, number] = [
  120.5868, 13.1168, 122.8870, 15.2169,
];

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

/** Class 1 (coconut). Class 0 stays hidden. */
export const COCONUT_CROP_COLOR = CROP_AREA_COLOR;

export const COCONUT_CROP_LEGEND = {
  colors: [COCONUT_CROP_COLOR],
  labels: ['Coconut'],
  description: 'Coconut areas',
};

export function buildCoconutCropTileUrl(cogUrl: string = COCONUT_CROP_COG_URL): string {
  const params = new URLSearchParams();
  params.set('url', cogUrl);
  params.set('bidx', '1');
  params.set('colormap', JSON.stringify({ '1': COCONUT_CROP_COLOR }));
  params.set('nodata', '0');
  params.set('resampling', 'nearest');
  return `${TITILER_TILE_BASE}?${params.toString()}`;
}
